/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import GtmEvent from "web/Layout/Gtm/GtmEvent";
import __ from "web/Layout/Translations";

import Button from "web/Components/Common/ButtonCC";

import CartSadIcon from "web/assets/icons/cart-sad.svg";

import getPageReferrer from "web/utils/system/GTM/getPageReferrer";

import urls from "web/constants/urls";

import { useAppContext } from "web/context/app";

import classes from "./failed.scss";

const CheckoutFailed = () => {
  const { isMobile } = useAppContext();
  const location = useLocation();
  const gtmOptions = useMemo(
    () => ({
      cgroup1: "Koszyk",
      cgroup2: "Zamówienie nie zostało złożone",
      page_referrer: getPageReferrer(location),
    }),
    [location, getPageReferrer]
  );

  return (
    <>
      <div className={`container ${classes.container}`}>
        {!isMobile ? (
          <h1 className={classes.banner}>
            <span
              className={classes.bannerTitle}
              data-t1="checkout_failed_title"
            >
              {__("Błąd!")}
            </span>
            <span className={classes.bannerText} data-t1="checkout_failed_text">
              {__("nieudana płatność")}
            </span>
            <span className={classes.bannerIcon}>
              <CartSadIcon width={220} />
            </span>
          </h1>
        ) : (
          <>
            <h1
              className={classes.headerTitle}
              data-t1="ccheckout_failed_title"
            >
              {__("Błąd!")}
            </h1>
            <h1 className={classes.headerText} data-t1="checkout_failed_text">
              {__("nieudana płatność")}
            </h1>
          </>
        )}
        <p
          className={isMobile ? classes.descriptionMobile : classes.description}
          data-t1="checkout_failed_description"
        >
          {__("Wystąpił błąd podczas przetwarzania płatności!")}
          <br />
          {__("Twoje zamówienie nie zostało opłacone i zostanie anulowane.")}
        </p>
        <h2
          className={isMobile ? classes.titleMobile : classes.title}
          data-t1="checkout_failed_subtitle"
        >
          {__("Co teraz?")}
        </h2>
        <p
          className={isMobile ? classes.textMobile : classes.text}
          data-t1="checkout_failed_info"
        >
          {__(
            "Jeśli podczas zamówienia wystąpił błąd, prosimy o skontaktowanie się z administratorem."
          )}
        </p>
        <div className={classes.buttonWrapper}>
          <Button
            to={urls.home}
            variant="tertiary"
            dataT1="checkout_failed_continue"
          >
            {__("Kontynuuj zakupy")}
          </Button>
        </div>
        {isMobile ? (
          <div className={classes.bannerMobile}>
            <span className={classes.bannerIcon}>
              <CartSadIcon />
            </span>
          </div>
        ) : null}
      </div>
      <GtmEvent options={gtmOptions} withUrl />
    </>
  );
};

export default CheckoutFailed;
